var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProfileManagement(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.7826 4.34888H17.8164M13.7826 6.76917H17.8164M16.2029 9.18946H17.8164M4.16597 12.6553C3.18333 13.2507 0.606526 14.4649 2.17649 15.984C2.94291 16.7262 3.79727 17.2571 4.87108 17.2571H10.9968C12.0698 17.2571 12.9242 16.7262 13.6914 15.984C15.2606 14.4649 12.683 13.2499 11.7003 12.6553C10.5629 11.9713 9.26076 11.61 7.93355 11.61C6.60634 11.61 5.30337 11.9713 4.16597 12.6553ZM10.9589 5.9624C10.9589 6.81827 10.6189 7.63909 10.0137 8.24428C9.40854 8.84947 8.58773 9.18946 7.73186 9.18946C6.87599 9.18946 6.05518 8.84947 5.44999 8.24428C4.8448 7.63909 4.50481 6.81827 4.50481 5.9624C4.50481 5.10654 4.8448 4.28572 5.44999 3.68053C6.05518 3.07534 6.87599 2.73535 7.73186 2.73535C8.58773 2.73535 9.40854 3.07534 10.0137 3.68053C10.6189 4.28572 10.9589 5.10654 10.9589 5.9624Z",
    stroke: "#4A4A4A",
    strokeWidth: 1.21014,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileManagement);
export default __webpack_public_path__ + "static/media/ProfileManagement.d9194ee545d2fbd902a6a3b9b33f2da8.svg";
export { ForwardRef as ReactComponent };